export class Player {
    private _name: string;
    private _score = 0;

    constructor(name = '') {
        this._name = name;
    }


    get score(): number {
        return this._score;
    }

    set score(value: number) {
        this._score = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }
}